/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { FormGroup, Button, Form, TextInput, ComboBox } from 'carbon-components-react';
import Close16 from '@carbon/icons-react/lib/close/16';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, STATUS, apioperation, entitiesLabels } from '../../helpers/Constants';
import Combo from '../common/Combo';
import MeRepository from '../../helpers/api/MeRepository';
import { me, drill } from '../../helpers/api/api';

export default class DrillFilterModal extends Component {
  constructor(props) {
    super(props);
    this.defaultGuid = null; // "00000000-0000-0000-0000-000000000000";
    this.weeks = [...Array(53).keys()].map((x) => `${x + 1}`);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.updateState = this.updateState.bind(this);

    this.statuses = STATUS;
    this.state = {
      search: {
        isBack:  false, //this.props.checkBack,
        division: this.props.searchModel?.division || null,
        company: this.props.searchModel?.company || null,
        participant: this.props.searchModel?.participant || null,
        status: this.props.searchModel?.status || null,
        workSite: this.props.searchModel?.workSite || null,
        project: this.props.searchModel?.project || null,
        drillType: this.props.searchModel?.drillType || null,
        drillTypeDetail: this.props.searchModel?.drillTypeDetail || null,
        frequency: this.props.searchModel?.frequency || null,

        idDivision: this.props.searchModel?.idDivision || this.defaultGuid,
        idProject: this.props.searchModel?.idProject || this.defaultGuid,
        idParticipant: this.props.searchModel?.idParticipant || this.defaultGuid,
        idCompany: this.props.searchModel?.idCompany || this.defaultGuid,
        idStatus: this.props.searchModel?.idStatus || 0,
        idWorkSite: this.props.searchModel?.idWorkSite || this.defaultGuid,
        idDrillType: this.props.searchModel?.idDrillType || this.defaultGuid,
        idDrillTypeDetail: this.props.searchModel?.idDrillTypeDetail || this.defaultGuid,
        idFrequency: this.props.searchModel?.idFrequency || this.defaultGuid,
        plannedWeek: this.props.searchModel?.plannedWeek || null,
        // referenceYear: this.props.searchModel?.referenceYear || new Date().getFullYear(),
        monthNumber: this.props.searchModel?.monthNumber || null,
        code: this.props.searchModel?.code || null,
        compilerEmail: this.props.searchModel?.compilerEmail || null,
        dataApproverEmail: this.props.searchModel?.dataApproverEmail || null,
        drillerEmail: this.props.searchModel?.drillerEmail || null,
      },
      divisions: [],
      appAllDrillTypeDT: [],
      appAllDrillType: [],
      appAllWorksites: null,
      appAllProjects: null,
      isLoading : true,
    };
  }
  componentDidMount() {
    this.getAllDivision();
    this.getAllWorkSite();
    this.getAllProjects();
    this.getAllDrillType();
    this.getAllDrillTypeDT();
  }
  getAllDivision = () => {
    this.setState({
      isLoadingDivision: true,
    });
    MeRepository.getDivisions()
      .then((response) => {
        this.setState({
          divisions: response,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.DIVISION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingDivision: false,
        });
      });
  };
  getAllWorkSite = () => {
    this.setState({
      isLoadingWorksite: true,
    });
    me.getAll('worksites')
      .then((response) => {
        this.setState({
          appAllWorksites: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingWorksite: false,
        });
      });
  };
  getAllProjects = () => {
    this.setState({
      isLoadingProject: true,
    });
    me.getAll('project')
      .then((response) => {
        this.setState({
          appAllProjects: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingProject: false,
        });
      });
  };
  getAllDrillType = () => {
    this.setState({
      isLoadingDrillType: true,
    });
    drill
      .get('drilltype')
      .then((response) => {
        this.setState({
          appAllDrillType: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingDrillType: false,
        });
      });
  };
  getAllDrillTypeDT = () => {
    this.setState({
      isLoadingDrillTypeDT: true,
    });
    drill
      .get('drilltype/drilltypedetails')
      .then((response) => {
        this.setState({
          appAllDrillTypeDT: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingDrillTypeDT: false,
        });
      });
  };
  getWorksiteFiltered(idDivision) {
    if (idDivision != null) {
      const data = (this.state.appAllWorksites || []).filter((el) => el.idDivision === idDivision);
      return data;
    }
    return this.state.appAllWorksites;
  }
  getProjectFiltered(idProject) {
    if (idProject != null) {
      const data = (this.state.appAllProjects || []).filter((el) => el.id === idProject);
      return data;
    }
    return this.state.appAllProjects;
  }
  getDrillTypeDetailFiltered(idDrillType) {
    if (idDrillType != null) {
      const data = (this.state.appAllDrillTypeDT || []).filter(
        (el) => el.idDrillType === idDrillType
      );
      return data;
    }
    return this.state.appAllWorksitePrj;
  }

  handleSearch = (e) => {
    this.props.onSearch(e, this.state.search);
  };

  handleCancel = (e) => {
    this.props.onCancel(e, this.state.search);
  };

  handleClose = (e) => {
    this.props.onClose(e, this.state.search);
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.search.isBack = false;
    this.setState(statusCopy);
  };

  handleChangeCode = (el) => {
    const inputName = 'code';
    const inputValue = el.target.value;
    const objName = 'search';
    this.updateState(inputName, inputValue, objName);
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;
    this.updateState(inputName, inputValue, objName);
  };

  render() {
 
    const listWorksite = this.state.search.idDivision
      ? this.getWorksiteFiltered(this.state.search.idDivision)
      : this.state.appAllWorksites
      ? this.state.appAllWorksites
      : [];
    const listProjects = this.state.search.idProject 
      ? this.getProjectFiltered(this.state.search.idProject)
      : this.state.appAllProjects
      ? this.state.appAllProjects
      : []
    const listDrillTypeDetail = this.state.search.idDrillType
      ? this.getDrillTypeDetailFiltered(this.state.search.idDrillType)
      : this.state.appAllDrillTypeDT
      ? this.state.appAllDrillTypeDT
      : [];
    const selectedItemCombo = {
      idDrillType: this.state.search.idDrillType
        ? (this.state.appAllDrillType || []).find((el) => el.id === this.state.search?.idDrillType)
        : [],
      idDrillTypeDetail: this.state.search.idDrillTypeDetail
        ? (listDrillTypeDetail || []).find((el) => el.id === this.state.search.idDrillTypeDetail)
        : [],
      idDivision: this.state.search.idDivision
        ? (this.state.divisions  || []).find((el) => el.id === this.state.search?.division?.id)
        : [],
      idWorkSite: this.state.search.idWorkSite
        ? (listWorksite || []).find((el) => el.id === this.state.search.idWorkSite)
        : [],
      idProject: this.state.search.idProject
        ? (listProjects || []).find((el) => el.id === this.state.search.idProject)
        : [],
      
    };
    return (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container modal-container-custom">
          <div className="modal-header">
            <h3 className="bx--modal-header"> Filters </h3>
            <Button className="bx--modal-close" renderIcon={Close16} onClick={this.props.onClose} />
          </div>
          <Form autoComplete="off" onSubmit={this.handleClickSearch}>
            <div className="bx--row">
              <div className="bx--col-lg-4 bx--col-md-6">
                {/* RITM0945977 */}
                {/* <FormGroup legendText="Division"> */}
                <FormGroup legendText="Business Line">
                  {/*<Combo
                    id="DivisionDrill"
                    url="me/divisions"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.division = event.selectedItem || null;
                        search.idDivision = search.division?.id;
                        return { search };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.DIVISION, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.search.division}
                    disabled={false}
                    entity={this.state.search.division?.id}
                    placeholder="All"
                  />*/}
                  <ComboBox
                    key={'idDivision_' + selectedItemCombo.idDivision}
                    id="idDivision"
                    placeholder="Select"
                    name="idDivision"
                    alt="search"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.division = event.selectedItem || null;
                        search.idDivision = search.division?.id;
                        search.isBack = false;
                        search.workSite = null;
                        return { search };
                      })
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={
                      selectedItemCombo.idDivision ? selectedItemCombo.idDivision : {}
                    }
                    items={this.state.divisions}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Company">
                  <Combo
                    id="CompanyDrill"
                    url="me/companies"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.company = event.selectedItem || null;
                        search.idCompany = search.company?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    disabled={false}
                    initialSelectedItems={this.state.search.company}
                    placeholder="All"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Work Site">
                  {/*<Combo
                    id="WorkSiteDrill"
                    url="me/workSites"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.workSite = event.selectedItem || null;
                        search.idWorkSite = search.workSite?.id;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    initialSelectedItems={this.state.search.workSite}
                    disabled={false}
                    entity={this.state.search.workSite?.id}
                    placeholder="All"
                  />*/}
                  <ComboBox
                    id="idWorkSite"
                    key={'idWorkSite_' + selectedItemCombo.idWorkSite}
                    placeholder="Select"
                    name="idWorkSite"
                    alt="search"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.workSite = event.selectedItem || null;
                        search.idWorkSite = search.workSite?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.idWorkSite}
                    items={listWorksite}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Project">
                  <ComboBox
                    id="idProject"
                    key={'idProject_' + selectedItemCombo.idProject}
                    placeholder="Select"
                    name="idProject"
                    alt="search"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.project = event.selectedItem || null;
                        search.idProject = search.project?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.idProject ? selectedItemCombo.idProject : {}}
                    items={listProjects}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText=" Status">
                  <Combo
                    id="StatusDrill"
                    url="/registry/status?page=0"
                    initialSelectedItems={this.state.search.status || null}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.status = event.selectedItem || null;
                        search.idStatus = search.status?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    itemToString={(item) => item?.planningName || ''}
                    disabled={false}
                    entity={this.state.search.status?.id}
                    placeholder="All"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Participant">
                  <Combo
                    id="ParticipantDrill"
                    url="drill/participant"
                    initialSelectedItems={this.state.search.participant || null}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.participant = event.selectedItem || null;
                        search.idParticipant = search.participant?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    // itemToString={(item) => item || ''}
                    disabled={false}
                    placeholder="All"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Frequency">
                  <Combo
                    id="FrequencyDrill"
                    url="drill/frequency"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.frequency = event.selectedItem || null;
                        search.idFrequency = search.frequency?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    initialSelectedItems={this.state.search.frequency}
                    disabled={false}
                    entity={this.state.search.frequency?.id}
                    placeholder="All"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Drill Type">
                  {/*<Combo
                    id="Drill Type"
                    url="drill/drilltype"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.drillType = event.selectedItem || null;
                        search.idDrillType = search.drillType?.id;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    initialSelectedItems={this.state.search.drillType}
                    disabled={false}
                    entity={this.state.search.drillType?.id}
                    placeholder="All"
                  />*/}
                  <ComboBox
                    key={'idDrillType' + selectedItemCombo.idDrillType}
                    id="idDrillType"
                    placeholder="Select"
                    name="idDrillType"
                    alt="search"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.drillType = event.selectedItem || null;
                        search.idDrillType = search.drillType?.id;
                        search.isBack = false;
                        //if (search.drillType?.name === 'LCU') search.projects = []; //RITM1290744
                        if (search.drillType?.name === 'Country LCU') search.projects = [];
                        return { search };
                      })
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={
                      selectedItemCombo.idDrillType ? selectedItemCombo.idDrillType : {}
                    }
                    items={this.state.appAllDrillType}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Drill Type Detail">
                  {/*<Combo
                    id="Drill Type Detail"
                    url="drill/drilltype/drilltypedetails"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.drillTypeDetail = event.selectedItem || null;
                        search.idDrillTypeDetail = search.drillTypeDetail?.id;
                        return { search };
                      })
                    }
                    onError={() => {}}
                    key="this.state.search.drillTypeDetail?.id"
                    initialSelectedItems={this.state.search.drillTypeDetail}
                    disabled={false}
                    entity={this.state.search.drillTypeDetail?.id}
                    placeholder="All"
                  />*/}
                  <ComboBox
                    key={'idDrillTypeDetail' + selectedItemCombo.idDrillTypeDetail}
                    id="idDrillTypeDetail"
                    placeholder="Select"
                    name="idDrillTypeDetail"
                    alt="search"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const search = { ...prevState.search };
                        search.drillTypeDetail = event.selectedItem || null;
                        search.idDrillTypeDetail = search.drillTypeDetail?.id;
                        search.isBack = false;
                        return { search };
                      })
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={
                      selectedItemCombo.idDrillTypeDetail ? selectedItemCombo.idDrillTypeDetail : {}
                    }
                    items={listDrillTypeDetail}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
   

              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Code">
                  <TextInput
                    id="CodeDrill"
                    name="CodeDrillName"
                    placeholder="Input Code"
                    value={this.state.search.code}
                    onChange={this.handleChangeCode}
                    type="text"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Email Compiler">
                  <TextInput
                    id="EmailCompiler"
                    name="compilerEmail"
                    placeholder="Input Email Compiler"
                    value={this.state.search.compilerEmail}
                    onChange={this.handleChangeModel}
                    type="text"
                    alt="search"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Email Data Approver">
                  <TextInput
                    id="EmailDataApprover"
                    name="dataApproverEmail"
                    placeholder="Input Code"
                    value={this.state.search.dataApproverEmail}
                    onChange={this.handleChangeModel}
                    type="text"
                    alt="search"
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-4 bx--col-md-6">
                <FormGroup legendText="Email Report Compiler">
                  <TextInput
                    id="EmailDriller"
                    name="drillerEmail"
                    placeholder="Input Email Report Compiler"
                    value={this.state.search.drillerEmail}
                    onChange={this.handleChangeModel}
                    type="text"
                    alt="search"
                  />
                </FormGroup>
              </div>
            </div>
          </Form>
          <div className="searchFormFooter">
            <Button
              className="button--max-width"
              size="small"
              kind="secondary"
              onClick={this.handleCancel}
            >
              Cancel
            </Button>
            <Button className="button--max-width" size="small" onClick={this.handleSearch}>
              Search
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
